import { Api } from './Api'
import { axiosInstance } from './axios'

export class TagService extends Api {
    protected TAG_GROUP = 'v1/tagGroup'
    protected TAG = 'v1/tag'

    getTagsOnMain = async () => {
        const tags = await axiosInstance.get(`${this.URL}/${this.TAG}?showOnMain=true&isDisabled=false`)
        return tags.data
    }

    getTagGroups = async () => {
        const groups = await axiosInstance.get<TagService[]>(`${this.URL}/${this.TAG_GROUP}?isDeleted=false&isDisabled=false`)
        return groups.data
    }
}